import { useEffect, useState } from "react";
import logo from "../assets/img/logo.png";
import { Link } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { toast, ToastContainer } from "react-toastify";
import { FaEnvelope } from "react-icons/fa";

const ForgetPassword = () => {
    const [email, setEmail] = useState("");

    useEffect(() => {
        const yearSpan = document.getElementById("year");
        if (yearSpan) {
            yearSpan.textContent = new Date().getFullYear().toString();
        }
    }, []);

    const handleReset = async (e) => {
        e.preventDefault();

        if (!email) {
            toast.error("Please enter your email address.");
            return;
        }

        try {
            await sendPasswordResetEmail(auth, email);
            toast.success("Password reset email sent! Please check your inbox.");
        } catch (error) {
            console.error("Reset failed", error.message);
            toast.error("Failed to send reset email. Please try again.");
        }
    };

    return (
        <div
            style={{
                background: "linear-gradient(to bottom right, #007bff, #0056b3)",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                margin: 0,
            }}
        >
            <div className="logo text-center mb-4">
                <img src={logo} alt="MReloadpay Logo" style={{ width: "100px" }} />
            </div>

            <div
                className="reset-card"
                style={{
                    background: "rgba(255, 255, 255, 0.9)",
                    padding: "30px 20px",
                    borderRadius: "15px",
                    width: "100%",
                    maxWidth: "400px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                }}
            >
                <h2
                    style={{
                        textAlign: "center",
                        marginBottom: "20px",
                        color: "#0056b3",
                        fontSize: "20px",
                        fontWeight: "bold",
                    }}
                >
                    Reset Password
                </h2>

                <form onSubmit={handleReset}>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">
                            Email Address
                        </label>
                        <div style={{ position: "relative" }}>
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <FaEnvelope
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: "10px",
                                    transform: "translateY(-50%)",
                                    color: "#555",
                                }}
                            />
                        </div>
                    </div>

                    <div className="d-grid">
                        <button type="submit" className="btn btn-primary">
                            Send Reset Link
                        </button>
                    </div>
                </form>

                <p className="text-center py-2">
                    <Link to="/signin" className="text-decoration-none">
                        Back to Sign in
                    </Link>
                </p>
            </div>

            <div
                className="footer mt-3"
                style={{ color: "#ffffffcc", fontSize: "14px", textAlign: "center" }}
            >
                © <span id="year"></span>, MReloadpay
            </div>

            <ToastContainer />
        </div>
    );
};

export default ForgetPassword;
